"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHeuristic = exports.useResponsive = exports.useBreakpoint = exports.ResponsiveContext = void 0;
var react_1 = __importStar(require("react"));
var theme_1 = require("src/providers/theme");
exports.ResponsiveContext = (0, react_1.createContext)('MD');
var ResponsiveProvider = function (_a) {
    var children = _a.children, breakpoint = _a.breakpoint;
    return (react_1.default.createElement(exports.ResponsiveContext.Provider, { value: breakpoint }, children));
};
var useBreakpoint = function () { return (0, react_1.useContext)(exports.ResponsiveContext); };
exports.useBreakpoint = useBreakpoint;
var toCamelCase = function (text) {
    return text
        .split('_')
        .map(function (c) { return "" + c[0] + c.slice(1).toLowerCase(); })
        .join('');
};
var useResponsive = function () {
    var supportedBreakpoints = (0, theme_1.useTheme)().supportedBreakpoints;
    var breakpoint = (0, exports.useBreakpoint)();
    return (0, react_1.useMemo)(function () { return supportedBreakpoints.reduce(function (acc, bp) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a["is" + toCamelCase(bp)] = bp === breakpoint, _a)));
    }, {}); }, [breakpoint, supportedBreakpoints]);
};
exports.useResponsive = useResponsive;
var useHeuristic = function () {
    var heuristicBreakpoints = (0, theme_1.useTheme)().heuristicBreakpoints;
    var breakpoint = (0, exports.useBreakpoint)();
    return (0, react_1.useMemo)(function () { return ({
        isSmall: heuristicBreakpoints.small.includes(breakpoint),
        isMedium: heuristicBreakpoints.medium.includes(breakpoint),
        isLarge: heuristicBreakpoints.large.includes(breakpoint),
    }); }, [breakpoint, heuristicBreakpoints]);
};
exports.useHeuristic = useHeuristic;
exports.default = ResponsiveProvider;
